import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

const closeAiGenerationResetModal = () => closePopupHelper(popupNames.AI_GENERATION_RESET_MODAL);

export const openAiGenerationResetModal = () =>
    openPopupHelper({ popupName: popupNames.AI_GENERATION_RESET_MODAL, onClose: closeAiGenerationResetModal });
